import React from "react";
import { useTheme } from "styled-components";
import { ISize } from "../../../classes/interfaces";
import Icon from "../../../components/ui/Icon";
import { Row, Info, Title, Description } from "./ProductCard.styles";

interface SizeCardProps {
  size: ISize;
  onOpen: (size: ISize) => void;
  /** Posição na lista, para a entrada em cascata (delay progressivo). */
  index?: number;
}

export default function SizeCard({ size, onOpen, index }: SizeCardProps) {
  const theme = useTheme();

  return (
    <Row $index={index} onClick={() => onOpen(size)}>
      <Info>
        <Title>{size.name}</Title>
        <Description>
          {size.fractionalMaximum > 1 ? "Escolha até " + size.fractionalMaximum + " sabores" : "Escolha o sabor"}
        </Description>
      </Info>
      <Icon name="chevron" size={18} color={theme.tokens.colors.muted} />
    </Row>
  );
}
